import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import {
  dcDaywiseAlarm,
  dcNonCompliance,
  dcNonComplianceInput
} from './model/dcOECompliance.model';

@Injectable()
export class NonComplianceService {
  constructor(private httpService: HttpService) {}

  public getNonComplianceData(input: dcNonComplianceInput) {
    return this.httpService.post<dcNonCompliance>('NonCompliance/GetNonComplianceData', input);
  }

  public getDayWiseAlarms(input: dcNonComplianceInput) {
    return this.httpService.post<dcDaywiseAlarm[]>('NonCompliance/GetDayWiseAlarms', input);
  }
}
